<template>
    <address class="address-text">
        <template v-if="address.country === 'MX'">
            <span v-if="address.street">{{address.street}}<br /></span>
            <span v-if="address.street2">{{address.street2}}<br /></span>
            <span v-if="address.district">{{address.district}}<br /></span>
            <span >{{address.postalCode}} {{address.city}}, {{address.region}}<br /></span>
        </template>
        <template v-else-if="address.country == 'US' || address.country == 'CA'">
            <span>{{address.street}}<br /></span>
            <span v-if="address.street2">{{address.street2}}<br /></span>
            <span >{{address.city}}, {{address.region}} {{address.postalCode}}<br /></span>
        </template>
        <!-- customize according to market format using template below -->
        <template v-else>
            <span>{{address.street}}<br /></span>
            <span v-if="address.street2">{{address.street2}}<br /></span>
            <span v-if="address.district">{{address.district}}<br /></span>
            <span >{{address.city}}, {{address.region}} {{address.postalCode}}<br /></span>
        </template>
    </address>
</template>

<script>
export default {
    name: 'FormattedAddress',
    props: {
        address: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

.address-text {
    font-style: normal;
    @include global.paragraph-l();
}
</style>
